export default __webpack_public_path__ + "media/images/loop_description-2aad382e34c957aa80f32a7099bf7d96.jpg";